import React from 'react';
import { GoogleMap, LoadScript, Marker, InfoWindow } from '@react-google-maps/api';
import { Title } from '../../atoms';

const MapContainer = ({ containerStyles, defaultCenter, title }) => {
  
  const mapStyles = { 
    ...containerStyles,       
    
    };
   

   
   
  
  
  return (
     <LoadScript
       googleMapsApiKey='AIzaSyCqjDcuqgug61jWOUHjDbvr31RAW9RqXrg'>
        <GoogleMap
          mapContainerStyle={mapStyles}
          zoom={13}
          center={defaultCenter}        
        >
          {<Marker 
          key={title} 
          position={defaultCenter}
          clickable={true}/>}
          
          <InfoWindow
              position={defaultCenter}
              clickable={true}
              onCloseClick={{}}
            >
              <p>{title}</p>
            </InfoWindow>
        </GoogleMap>
     </LoadScript>
  )
}

export default MapContainer;